<template>
  <div class="inline" :class="{disabled}" @click.prevent="click">
    <v-radio :label="label" :value="value" />
    <slot v-if="indent == null || indent === false" name="default" :selected="!disabled" />
    <div v-if="indent === '' || indent === true" class="indent inline ma-0 pa-0">
      <slot name="default" :selected="!disabled" />
    </div>
  </div>
</template>

<script>
import displayMixin from "@/mixins/display";

export default {
  props: ["label", "value", "indent"],
  mixins: [displayMixin],
  computed: {
    disabled() {
      return this.$parent.value !== this.value;
    }
  },
  methods: {
    click() {
      this.$parent.$emit("change", this.value);
    }
  }
};
</script>

<style lang="scss" scoped>
.indent {
  position: relative;
  top: -10px;
  left: 30px;
  width: 100%;
}
</style>